module.exports = __webpack_public_path__ + "static/img/led_l_5.6620423.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/led/led_l_5.png
// module id = VIS3
// module chunks = 4